import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import PoorFundsCalculator from './PoorFundsCalculator';

const PoorFundsInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Fund Switch Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Fund Switch Calculator helps you analyze the potential benefits of switching from underperforming funds to better-performing ones. It provides a detailed comparison of your current fund's performance with alternative funds, helping you make informed investment decisions.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Current Fund Value</li>
        <li>Current Fund Returns</li>
        <li>Alternative Fund Returns</li>
        <li>Switching Costs</li>
        <li>Investment Horizon</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator uses a comprehensive approach to determine the potential benefits of fund switching:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Compares historical performance of current and alternative funds</li>
        <li>Calculates potential returns from switching</li>
        <li>Considers switching costs and tax implications</li>
        <li>Provides break-even analysis</li>
        <li>Generates detailed performance comparison</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Identify underperforming funds</li>
        <li>Compare with better-performing alternatives</li>
        <li>Analyze switching costs</li>
        <li>Make informed fund switching decisions</li>
        <li>Optimize investment portfolio</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your current fund value, returns, and details about alternative funds to calculate the potential benefits of switching. The calculator will provide a detailed analysis of performance differences and switching costs.</p>
    </div>
  );
};

const PoorFunds = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <PoorFundsCalculator/>
        </div>
        <PoorFundsInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default PoorFunds;